import { formatMileage } from "./number_helpers"
import { generateHashtag } from "./text_helpers"

export const generateStockText = stock => {
  if (!stock || typeof stock !== "object") return "No stock data available"

  const safe = value =>
    value?.name?.trim?.() ||
    (typeof value === "string" ? value.trim() : value) ||
    "-"

  return `
🚗 ${safe(stock.brand)} ${safe(stock.model)} ${safe(stock.package)} ${safe(
    stock.engine_type
  )} ${safe(stock.year)} ${safe(stock.exterior_color)}

📦 Package: ${safe(stock.package)}  
📅 Year: ${safe(stock.year)}  
⚙️ Engine CC: ${safe(stock.engine_c_c)}  
🔄 Transmission: ${safe(stock.transmission)}  
⛽ Fuel Type: ${safe(stock.fuel_type)}  
🔑 Key Type: ${safe(stock.key_type)}  
🎨 Color: ${safe(stock.exterior_color)} | Interior: ${safe(
    stock.interior_color
  )}  
🏆 Auction Grade: ${safe(stock.auction_grade)}  
📏 Mileage: ${formatMileage(stock.mileage)}  
🚪 Doors: ${stock.doors || "-"} | 💺 Seats: ${stock.seats || "-"}  
🛞 Tire Size: ${stock.tire_size || "-"}  

🗂 Stock ID: ${stock.stock_id || "-"}  
🔧 Chassis Code: ${safe(stock.chassis_code)}  
🛠 Engine Code: ${safe(stock.engine_code)}  
📍 Location: ${safe(stock.location)}  

${stock.stock_id ? generateHashtag(stock.stock_id) : ""}
  `.trim()
}

export const generateStockTitle = stock => {
  if (!stock || typeof stock !== "object") return ""

  const getName = key => stock?.[key]?.name?.trim?.() || ""

  const parts = [
    getName("brand"),
    getName("model"),
    getName("engine_type"),
  ].filter(Boolean) // removes empty values

  return parts.join(" ")
}
